import { loadHome } from './Home/client/home-loader';

export * from './ConditionCategories/Components/client/conditionCategoryFilter.component';

export function loadComponents(): void {
  loadHome();
}
